import { Skeleton } from "@/core/components/ui/skeleton";

/** Skeleton that occupies the exceeded credits card space while data loads. */
export function ExceededCreditsCardSkeleton() {
  return (
    <div className="rounded-[16px] overflow-hidden min-h-[200px] flex flex-col shadow-sm">
      <div className="flex justify-between items-center px-4 py-3 bg-muted/50">
        <Skeleton className="w-28 h-4 rounded" />
        <Skeleton className="w-20 h-6 rounded-full" />
      </div>
      <div className="flex-1 p-[2px] bg-muted/30 rounded-b-2xl">
        <div className="bg-white rounded-b-[14px] h-full p-5 flex flex-col min-h-[180px]">
          <Skeleton className="mb-3 w-10 h-10 rounded-full" />
          <Skeleton className="mb-2 w-24 h-3 rounded" />
          <Skeleton className="h-7 w-full rounded mb-2 max-w-[85%]" />
          <Skeleton className="mb-auto w-3/4 h-7 rounded" />
          <Skeleton className="mt-4 w-full h-10 rounded-lg" />
        </div>
      </div>
    </div>
  );
}
